import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '..';
import { HeaderLoaded } from './header.actions';
@Injectable({
  providedIn: 'root',
})
export class HeaderFacade {
  constructor(private store: Store<IAppState>) {}

  headerLoaded() {
    this.store.dispatch(new HeaderLoaded());
  }
}
